import { LucideInfo } from 'lucide-react'
import { Flex, Label, Text } from 'ui'
import { Tooltip } from '@workwhile/ui'
import { TimelineShift } from 'api/shift'
import { WorkShift } from 'typings/common_defs'

interface Props {
  shift: TimelineShift | WorkShift
  size?: 'small' | 'medium' | 'large'
}

/**
 * Badge shown on a shift that belongs to a bundled listing (position.bundling = instance),
 * i.e. a group of shifts that workers accept and see together as a single Listing.
 */
export const BundledShiftLabel = ({ shift, size = 'medium' }: Props) => {
  const bundleSize = shift.bundleMetadata?.bundleSize ?? 0

  if (shift.isTryout || !shift.bundleMetadata || bundleSize <= 1) {
    return null
  }

  return (
    <Tooltip
      content={`This shift is part of a bundled listing of ${bundleSize} shifts. Workers typically accept the whole group together, rather than individual shifts.`}
      variant="neutral"
    >
      <Label variant="neutral" size={size} style={{ cursor: 'default' }}>
        <Flex flexDirection="row" alignItems="center">
          <Text>Bundled ({bundleSize} shifts)</Text>
          <Flex ml={2}>
            <LucideInfo size={14} />
          </Flex>
        </Flex>
      </Label>
    </Tooltip>
  )
}
